// extracted by css-extract-rspack-plugin
export default {"cls1":"AboutTheAuthorsSection-cls1_8jj","cls2":"AboutTheAuthorsSection-cls2_m7J AboutTheAuthorsSection-cls1_8jj"};